/* unplugin-vue-components disabled */import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import CTitle from '@/components/CTitle.vue';
import CurrentSelect from './CurrentSelect.vue';
import CDateSelect from '@/components/CDateSelect.vue';
import { LineEchart } from '@/components/page-echarts';
import { getCurrentCurve, getOpenCloseTome, editVrmDeviceCollect } from '@/service/vibrationEquipment';
import { showToast } from 'vant';
export default defineComponent({
  components: {
    CTitle: CTitle,
    CurrentSelect: CurrentSelect,
    LineEchart: LineEchart,
    CDateSelect: CDateSelect
  },
  name: 'VibDeviceDetail',
  props: {
    id: {
      type: String,
      required: true
    },
    deviceName: {
      type: String
    },
    currentWarnValue: {
      type: String,
      required: true
    },
    vrmWarnValue: {
      type: String,
      required: true
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var today = dayjs().format('YYYY-MM-DD');
    var lineList = ref([]);
    var chartOption = ref({});
    var openCloseList = ref();
    var date = ref(today);
    var factoryId = route.query.factoryId;
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD');
    };
    // 任意整数或小数
    var pattern = /^[0-9]*([.][0-9]{1,2})?$/;
    var showDialog = ref(false);
    var newCurrentWarnValue = ref(props.currentWarnValue);
    var newVrmWarnValue = ref(props.vrmWarnValue);
    var confirmDate = function confirmDate(value) {
      date.value = formatDate(value);
      getLineChartData({
        date: formatDate(value),
        type: 0
      });
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data = {
                deviceId: Number(props.id),
                vrmWarnValue: newVrmWarnValue.value,
                currentWarnValue: newCurrentWarnValue.value
              };
              _context.next = 4;
              return editVrmDeviceCollect(data);
            case 4:
              showDialog.value = false;
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              showToast('修改失败');
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function onSubmit() {
        return _ref.apply(this, arguments);
      };
    }();
    // 获取折线图数据
    var getLineChartData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
        var _res$data;
        var noRepeatName, repeatName, repeatNumObj, res, resDataListData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              noRepeatName = []; //不重复
              repeatName = []; //重复
              repeatNumObj = {};
              _context2.next = 5;
              return getCurrentCurve(_objectSpread(_objectSpread({}, data), {}, {
                deviceId: unref(props.id),
                factoryId: Number(factoryId)
              }));
            case 5:
              res = _context2.sent;
              resDataListData = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.list[0]) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
              lineList.value = []; //它的变化会出发confirmCurrent函数
              //先获取重复和不重复项
              resDataListData.forEach(function (item) {
                if (!noRepeatName.includes(item.attrName)) {
                  noRepeatName.push(item.attrName);
                } else {
                  repeatName.push(item.attrName);
                }
              });
              resDataListData.forEach(function (item) {
                var text = item.attrName;
                // // 计算重复次数
                if (repeatName.includes(item.attrName)) {
                  repeatNumObj[item.attrName] = (repeatNumObj[item.attrName] ? repeatNumObj[item.attrName] : 0) + 1;
                  text = "".concat(item.attrName, " -").concat(repeatNumObj[item.attrName]);
                }
                var times = (item === null || item === void 0 ? void 0 : item.times) || [];
                times = times.map(function (item) {
                  return dayjs(item).format('HH:mm:ss');
                });
                ((item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.values)) && unref(lineList).push({
                  deviceKey: item.deviceKey,
                  text: text,
                  times: times,
                  value: (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.values) || []
                });
              });
              console.log(lineList.value, 'lineList');
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getLineChartData(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 当前的折线图
    var confirmCurrent = function confirmCurrent(item) {
      var _item$value;
      console.log(item, 'item');
      var lineDataLength = (item === null || item === void 0 || (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.length) || 0;
      var interval = lineDataLength / 10;
      var option = {
        lineData: (item === null || item === void 0 ? void 0 : item.value) || [],
        xLabels: (item === null || item === void 0 ? void 0 : item.times) || [],
        legendData: [''],
        yName: '',
        grid: {
          top: '30',
          left: '5%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        interval: interval === 0 ? 'auto' : Math.floor(interval),
        axisPointer: {
          label: {
            formatter: function formatter(params) {
              return "".concat(today, " ").concat((params === null || params === void 0 ? void 0 : params.value) || '无效时间');
            }
          }
        }
      };
      chartOption.value = option;
    };
    watch(function () {
      return props.id;
    }, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(value) {
        var data, timeData, timeResDataList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              getLineChartData({
                date: date.value,
                type: 0
              });
              // 近三天开机关机数据
              data = {
                date: today,
                type: 0,
                deviceId: value
              };
              _context3.next = 4;
              return getOpenCloseTome(data);
            case 4:
              timeData = _context3.sent;
              timeResDataList = timeData.list || [];
              timeResDataList = timeResDataList.map(function (item) {
                var startTime = dayjs(item.day_time).format('MM月DD日0点');
                var endTime = '24点';
                return _objectSpread(_objectSpread({}, item), {}, {
                  startTime: startTime,
                  endTime: endTime
                });
              });
              openCloseList.value = timeResDataList || [];
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    return {
      confirmCurrent: confirmCurrent,
      lineList: lineList,
      chartOption: chartOption,
      openCloseList: openCloseList,
      confirmDate: confirmDate,
      pattern: pattern,
      showDialog: showDialog,
      newCurrentWarnValue: newCurrentWarnValue,
      newVrmWarnValue: newVrmWarnValue,
      onSubmit: onSubmit
    };
  }
});